import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { AdminSidebar } from '@features/admin/components/AdminSidebar';
import { cn } from '@utils/cn';

export const AdminLayout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#070b14] text-slate-100 flex flex-col font-sans">
      {/* 
        Left Sidebar (Thanh Menu bên trái màn hình)
        Positioned fixed on the left edge of the screen
      */}
      <AdminSidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed((prev) => !prev)}
        isMobileOpen={isMobileOpen}
        onCloseMobile={() => setIsMobileOpen(false)}
      />

      {/* 
        Main Workspace Area
        Has margin-left matching the left sidebar width on desktop (lg:)
      */}
      <div
        className={cn(
          'flex min-h-screen flex-1 flex-col transition-all duration-300 ease-in-out',
          isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-72',
        )}
      >

        {/* Scrollable Page Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8 max-w-7xl w-full mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
